import TextLink from "../../../../components/TextLink";

export default function Impressum() {
  return (
    <p className="mt-20 text-xs text-start anta font-normal leading-relaxed">
      This portfolio was rebuilt by me using React.
      <br />
      The design and structure were inspired by{" "}
      <TextLink href="https://github.com/gommzystudio/portfolio">
        Julian Ambrozy’s portfolio
      </TextLink>
      .
      <br />
      <br />
      <strong>Le Huu Khoa</strong>
      <br />
      Vietnam
      <br />
      <br />
      You can find another detailed portfolio of mine here:{" "}
      <TextLink href="https://huuwkhoa.vercel.app/">Winfolio</TextLink>
      <br />
      <br />
      E-Mail: aohkne@gmail.com
    </p>
  );
}
